module.exports = __webpack_public_path__ + "media/images/user2_logo-f34f035fb6c030e4ec361e09447ef3f1.png";